import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiUploadCloud } from "react-icons/fi";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "styles/admin.css";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    role: "",
    username: "",
    password: "",
    confirmPassword: "",
    image: null,
    note: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData((prev) => ({ ...prev, image: files?.[0] ?? null }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const removeImage = (e) => {
    e.stopPropagation();
    setFormData((prev) => ({ ...prev, image: null }));
    document.getElementById("imageInput").value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      return toast.error("Parollar mos emas!");
    }

    const token = localStorage.getItem("accessToken");
    if (!token) {
      return toast.error("Admin sifatida tizimga kiring!");
    }

    setLoading(true);

    try {
      const data = new FormData();
      data.append("FirstName", formData.name.trim());
      data.append("LastName", formData.surname.trim());
      data.append("Username", formData.username.trim());
      data.append("Password", formData.password);
      data.append("ConfirmPassword", formData.confirmPassword);
      data.append("RoleId", formData.role === "teacher" ? "2" : "3");

      if (formData.note.trim()) data.append("Bio", formData.note.trim());
      if (formData.image) data.append("Image", formData.image);

      await axios.post(
        "https://algoritm-api-edu.uz/api/admin/Users/Register",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Foydalanuvchi muvaffaqiyatli qo‘shildi!");

      setFormData({
        name: "",
        surname: "",
        role: "",
        username: "",
        password: "",
        confirmPassword: "",
        image: null,
        note: "",
      });
      document.getElementById("imageInput").value = "";
    } catch (err) {
      const errorMsg = err.response?.data?.errors
        ? Object.values(err.response.data.errors).flat().join("\n")
        : err.response?.data?.message || "Noma'lum xato yuz berdi";

      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const formVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, staggerChildren: 0.1 },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      className="register-container"
      initial="hidden"
      animate="visible"
      variants={formVariants}
    >
      <form className="register-form" onSubmit={handleSubmit}>
        <motion.div className="form-group" variants={childVariants}>
          <label>
            Ism <span className="required">*</span>
          </label>
          <input
            type="text"
            name="name"
            placeholder="Ismingizni kiriting"
            maxLength={15}
            value={formData.name}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </motion.div>

        <motion.div className="form-group" variants={childVariants}>
          <label>
            Familiya <span className="required">*</span>
          </label>
          <input
            type="text"
            name="surname"
            placeholder="Familiyangizni kiriting"
            maxLength={15}
            value={formData.surname}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </motion.div>

        <motion.div className="form-group" variants={childVariants}>
          <label>
            Role <span className="required">*</span>
          </label>
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
            disabled={loading}
          >
            <option value="">Tanlang</option>
            <option value="teacher">O‘qituvchi</option>
            <option value="student">Talaba</option>
          </select>
        </motion.div>

        <motion.div className="form-group" variants={childVariants}>
          <label>
            Username <span className="required">*</span>
          </label>
          <input
            type="text"
            name="username"
            placeholder="Username kiriting"
            maxLength={32}
            value={formData.username}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </motion.div>

        <div className="form-row">
          <motion.div className="form-group" variants={childVariants}>
            <label>
              Parol <span className="required">*</span>
            </label>
            <input
              type="password"
              name="password"
              placeholder="Parolni kiriting"
              maxLength={32}
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </motion.div>

          <motion.div className="form-group" variants={childVariants}>
            <label>
              Parolni qayta kiriting <span className="required">*</span>
            </label>
            <input
              type="password"
              name="confirmPassword"
              placeholder="Parolni qayta kiriting"
              maxLength={32}
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </motion.div>
        </div>

        <motion.div className="form-group" variants={childVariants}>
          <label>Rasm (ixtiyoriy)</label>
          <motion.div
            className="image-upload-box"
            whileHover={{ scale: loading ? 1 : 1.03 }}
            whileTap={{ scale: loading ? 1 : 0.97 }}
            onClick={() =>
              !loading && document.getElementById("imageInput")?.click()
            }
          >
            <AnimatePresence mode="wait">
              {formData.image ? (
                <motion.div
                  key="image"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  className="file-info"
                >
                  <span className="file-name">{formData.image.name}</span>
                  <motion.span
                    className="remove-file"
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={removeImage}
                  >
                    ×
                  </motion.span>
                </motion.div>
              ) : (
                <motion.div
                  key="placeholder"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="upload-placeholder"
                >
                  <FiUploadCloud size={28} color="#666" />
                  <p>Rasm yuklang (PNG/JPG)</p>
                </motion.div>
              )}
            </AnimatePresence>

            <input
              id="imageInput"
              type="file"
              name="image"
              accept="image/*"
              hidden
              onChange={handleChange}
              disabled={loading}
            />
          </motion.div>
        </motion.div>

        <motion.div className="form-group" variants={childVariants}>
          <label>Izoh (ixtiyoriy)</label>
          <textarea
            name="note"
            placeholder="Qo‘shimcha ma'lumot..."
            maxLength={400}
            value={formData.note}
            onChange={handleChange}
            disabled={loading}
          />
        </motion.div>

        <motion.button
          type="submit"
          className="submit-btn"
          disabled={loading}
          whileHover={{ scale: loading ? 1 : 1.05 }}
          whileTap={{ scale: loading ? 1 : 0.95 }}
          variants={childVariants}
        >
          {loading ? "Qo'shilmoqda..." : "Foydalanuvchi qo‘shish"}
        </motion.button>
      </form>

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </motion.div>
  );
};

export default Register;
